/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40% off 80: you save 32, final price 48.`)
};

const es_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40% de descuento sobre 80: ahorras 32, precio final 48.`)
};

const de_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40 % Rabatt auf 80: du sparst 32, Endpreis 48.`)
};

const nl_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40% korting op 80: je bespaart 32, eindprijs 48.`)
};

const fr_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40 % de réduction sur 80 : vous économisez 32, prix final 48.`)
};

const it_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40% di sconto su 80: risparmi 32, prezzo finale 48.`)
};

const pt_br2_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40% de desconto em 80: você economiza 32, preço final 48.`)
};

const pt_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`40% de desconto em 80: poupa 32, preço final 48.`)
};

const ja_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`80の40%オフ: 節約額32、最終価格48。`)
};

const zh_pct_discount_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`80 打 40% 折扣：节省 32，最终价格 48。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_ex2", locale)
	if (locale === "en") return en_pct_discount_ex2(inputs)
	if (locale === "es") return es_pct_discount_ex2(inputs)
	if (locale === "de") return de_pct_discount_ex2(inputs)
	if (locale === "nl") return nl_pct_discount_ex2(inputs)
	if (locale === "fr") return fr_pct_discount_ex2(inputs)
	if (locale === "it") return it_pct_discount_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_ex2(inputs)
	if (locale === "pt") return pt_pct_discount_ex2(inputs)
	if (locale === "ja") return ja_pct_discount_ex2(inputs)
	return zh_pct_discount_ex2(inputs)
};